import Home from "@/views/Home.vue";
import About from "@/views/About.vue";
import { Trans } from "@/plugins/Translation";
import Unauthorized from "../views/Auth/Unauthorized.vue";
import Callback from "../views/Auth/Callback.vue";
import PODIndex from "@/views/POD/Index.vue";
import ClientConfigIndex from "@/views/ClientConfiguration/Index.vue";
import ClientConfigEdit from "@/views/ClientConfiguration/Edit.vue";
import GAApi from "../api/GA/GAApi";

const routes = [
    {
        path: "/:lang",
        component: {
            template: "<router-view></router-view>"
        },
        beforeEnter: Trans.routeMiddleware,
        children: [
            {
                path: "/",
                name: "Home",
                component: Home,
                redirect: "POD/Index",
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: "POD/Index",
                name: "Index",
                component: PODIndex,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "ClientConfiguration/Index",
                name: "ConfigIndex",
                component: ClientConfigIndex,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "ClientConfiguration/Edit/:Id?",
                name: "ConfigEdit",
                component: ClientConfigEdit,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "/about",
                name: "about",
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: About,
                meta: {
                    requiresAuth: true
                    // role: "base",
                    // function: "Menu Utente"
                }
            },
            {
                path: "callback",
                name: "callback",
                component: Callback,
                meta: {
                    requiresAuth: true
                    // role: "base",
                    // function: "Menu Utente"
                }
            },
            // {
            //   path: "unauthorized",
            //   name: "unauthorized",
            //   component: Unauthorized,
            //   meta: {
            //     requiresAuth: false
            //     // role: "base",
            //     // function: "Menu Utente"
            //   }
            // }
        ]
    },
    {
        path: "/",
        redirect(to) {
            window.location.href = Trans.getUserSupportedLang() + "/POD/Index";
        }
    },
    // {
    //   path: "/redirect",
    //   name: "redirect",
    //   component: Unauthorized,
    //   meta: {
    //     requiresAuth: false
    //     // role: "base",
    //     // function: "Menu Utente"
    //   },
    //   beforeEnter(to, from, next) {
    //     let sson = process.env.VUE_APP_SINGLESIGNON;
    //     let base64RedirectUrl = btoa(process.env.VUE_APP_PORTAL_URL);      
    //     console.log("sso", `${sson}/Home/Index?r=${base64RedirectUrl}`);
    //     window.location.replace(`${sson}/Home/Index?r=${base64RedirectUrl}`)
    //   }
    // },
    {
        path: "/unauthorized",
        name: "unauthorized",
        beforeEnter(to, from, next) {
            GAApi.GetAccessDeniedPage().then(result => {
                window.location.replace(result.data.Url);
            });
        },
        meta: {
            requiresAuth: false
            // role: "base",
            // function: "Menu Utente"
        }
    },
    {
        // Redirect user to supported lang version.
        path: "*",
        // eslint-disable-next-line
        redirect(to) {

            return Trans.getUserSupportedLang();
        }
    }
];

export default routes;
